var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.userManager.checkRole(['kt', 'vd', 'vdl']))?_c('div',[_vm._v("Bạn không có quyền truy cập trang này")]):_c('div',[(_vm.tableOptions)?_c('x-default-data-table',{attrs:{"x-options":_vm.tableOptions}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }